import { PtMembershipDto } from '#types/member';

export function formatKoreanDate(dateString?: string | null) {
  const today = dateString ? new Date(dateString || '') : new Date();

  // const year = today.getFullYear();
  const month = today.getMonth() + 1; // Months are 0-based, so we add 1.
  const date = today.getDate();
  const dayNames = ['일', '월', '화', '수', '목', '금', '토']; // Days of the week in Korean
  const day = dayNames[today.getDay()];

  return `${month}월 ${date}일 (${day})`;
}

export function getExpiryDate(
  startedDate: string,
  expiryPeriod: string | undefined,
  expiryDate: string | null | undefined
) {
  if (!startedDate) return '';

  if (expiryPeriod === 'custom') {
    return expiryDate;
  }

  // 유효기간이 없는 경우
  if (expiryPeriod === '0') {
    return '';
  }

  if (isNaN(new Date(startedDate).getTime())) {
    // 날짜가 유효하지 않을 때
    throw new Error('Invalid Date');
  }

  const startedDateObj = new Date(startedDate);

  const newExpiryDate = new Date();

  newExpiryDate.setDate(startedDateObj.getDate() + Number(expiryPeriod));

  return newExpiryDate.toISOString();
}

export const getSelectDefaultValue = ({
  name,
  isLoad,
  latestMembership
}: {
  name: string;
  isLoad: boolean | null | undefined;
  latestMembership: PtMembershipDto | null | undefined;
}) => {
  if (!isLoad || !latestMembership) return '선택';

  switch (name) {
    case 'totalRound':
      return `${latestMembership.totalRound}회차`;
    case 'isRequestPayment':
      return latestMembership.isPaid ? '결제 완료' : '결제 예정';
    default:
      return '선택';
  }
};
